import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
})
export class MultiselectComponent implements OnInit {
  @Input() items: any;
  @Input() isDisabled: boolean;

  constructor() { }

  ngOnInit() {}

  public selectItem(item: any): void {
    if (this.isDisabled) {
      return;
    }
    const selectedItem = this.items.find( (arrayItem) => arrayItem === item);
    selectedItem.selected = !selectedItem.selected;
  }

  public isSelected(item: any): boolean {
    return this.items.find( (arrayItem) => arrayItem === item).selected;
  }
}
